import Home from "../views/home/Home"
import NaoEncontrado from "../views/NaoEncontrado";


import Servidor from "../views/servidores/Servidor.vue";
import ServidorNew from "../views/servidores/ServidorNew.vue";
import ServidorShow from "../views/servidores/ServidorShow.vue";
import ServidorEdit from "../views/servidores/ServidorEdit.vue";

import Pergunta from "../views/pergunta/Pergunta.vue";
import PerguntaNew from "../views/pergunta/PerguntaNew.vue";
import PerguntaShow from "../views/pergunta/PerguntaShow.vue";
import PerguntaEdit from "../views/pergunta/PerguntaEdit.vue";

import Resposta from "../views/resposta/Resposta.vue";
import RespostaNew from "../views/resposta/RespostaNew.vue";
import RespostaShow from "../views/resposta/RespostaShow.vue";
import RespostaEdit from "../views/resposta/RespostaEdit.vue";

import Formulario from "../views/formulario/Formulario.vue";
import FormularioNew from "../views/formulario/FormularioNew.vue";
import FormularioShow from "../views/formulario/FormularioShow.vue";
import FormularioEdit from "../views/formulario/FormularioEdit.vue";
import FormularioReaproveitar from "../views/formulario/FormularioReaproveitar.vue";

//permissoes: funcionalidades do SGU no formato "recurso#acao"; basta ter uma delas
//  - "#index_show" libera listagem e detalhe; "#new_edit_destroy" libera criar, editar e excluir
//raiz indica se é uma rota que pode ser a inicial para o usuario que logar (normalmente vao ser so os indexes de cada crud)
//colocar as rotas em ordem de prioridade para login (as mais no topo vao ser a tela inicial do usuario se ele tiver permissao)

export default [
  {
    name: "Home",
    path: "/home",
    component: Home,
    meta: {
      raiz: true,
      requerPermissao: true,
      label: "Home",   
      permissoes: ["home#index_show"],   
    },
  },
    {
    name: "Formularios",
    path: "/formularios",
    component: Formulario, 
    meta: {
      raiz: true,
      requerPermissao: true,
      label: "Formulários",
      permissoes: ["formularios#index_show"],
    },
  },
  {
    name: "FormularioNew",
    path: "/formularios/formulario-new",
    component: FormularioNew, 
    meta: {
      requerPermissao: true,
      label: "Formularios",
      permissoes: ["formularios#new_edit_destroy"],
    },
  },
  {
    name: "FormularioShow",
    path: "/formularios/formulario-show/:id",
    component: FormularioShow, 
    meta: {
      requerPermissao: true,
      label: "Formularios",
      // home#index_show: quem só tem a Home abre o formulário pelos links dela
      permissoes: ["formularios#index_show", "home#index_show"]
    },
  },
  {
    name: "FormularioEdit",
    path: "/formularios/formulario-edit/:id",
    component: FormularioEdit,
    meta: {
      requerPermissao: true,
      label: "Formularios",
      permissoes: ["formularios#new_edit_destroy"],      
    },
  },
  {
    name: "FormularioReaproveitar",
    path: "/formularios/formulario-reaproveitar/:id",
    component: FormularioReaproveitar,
    meta: {
      requerPermissao: true,
      label: "Formularios",
      permissoes: ["formularios#new_edit_destroy"],      
    },
  },
  {
    name: "FormularioResponder",
    path: "/formularios/:id/responder",
    component: () => import("../views/formulario/ResponderFormulario.vue"), 
    props: true, 
    meta: {
      requerPermissao: true,
      // Responder a avaliação é feito pela Home.
      permissoes: ["home#index_show"],
    },
  },
  {
    name: "VisualizarRespostaFormulario",
    path: "/formularios/:id/visualizar-respostas",
    component: () => import("../views/formulario/VisualizarRespostaFormulario.vue"), 
    props: true, 
    meta: {
      requerPermissao: true,
      permissoes: ["formularios#index_show", "home#index_show"],
    },
  },
  {
    name: "Servidor",
    path: "/servidores",
    component: Servidor,
    meta: {
      raiz: true,      
      requerPermissao: true,
      permissoes: ["servidores#index_show"],
      label: "Servidores",         
    },
  },
  {
    name: "ServidorNew",
    path: "/servidores/new",
    component: ServidorNew,
    meta: {
      requerPermissao: true,
      permissoes: ["servidores#new_edit_destroy"],
      label: "Servidores",
    },
  },
  {
    name: "ServidorShow",
    path: "/servidores/:id",
    component: ServidorShow,
    meta: {
      requerPermissao: true,
      permissoes: ["servidores#index_show"],
      label: "Servidores",
    },
  },
  {
    name: "ServidorEdit",
    path: "/servidores/:id/edit",
    component: ServidorEdit,
    meta: {
      requerPermissao: true,
      permissoes: ["servidores#new_edit_destroy"],
      label: "Servidores",
    },
  },
  {
    name: "Perguntas",
    path: "/perguntas",
    component: Pergunta, 
    meta: {
      raiz: true,
      requerPermissao: true,
      label: "Perguntas",
      permissoes: ["perguntas#index_show"],
    },
  },
  {
    name: "PerguntaNew",
    path: "/perguntas/pergunta-new",
    component: PerguntaNew, 
    meta: {
      requerPermissao: true,
      label: "Perguntas",
      permissoes: ["perguntas#new_edit_destroy"],
    },
  },
  {
    name: "PerguntaShow",
    path: "/perguntas/pergunta-show/:id",
    component: PerguntaShow, 
    meta: {
      requerPermissao: true,
      label: "Perguntas",
      permissoes: ["perguntas#index_show"],
    },
  },
  {
    name: "PerguntaEdit",
    path: "/perguntas/pergunta-edit/:id",
    component: PerguntaEdit,
    meta: {
      requerPermissao: true,
      label: "Perguntas",
      permissoes: ["perguntas#new_edit_destroy"],
    },
  },
  {
    name: "Respostas",
    path: "/respostas",
    component: Resposta, 
    meta: {
      raiz: true,
      requerPermissao: true,
      label: "Respostas",
      permissoes: ["respostas#index_show"], 
    },
  },
  {
    name: "RespostaNew",
    path: "/respostas/resposta-new",
    component: RespostaNew, 
    meta: {
      requerPermissao: true,
      label: "Respostas",
      permissoes: ["respostas#new_edit_destroy"],
      
    },
  },
  {
    name: "RespostaShow",
    path: "/respostas/resposta-show/:id",
    component: RespostaShow, 
    meta: {
      requerPermissao: true,
      label: "Respostas",
      permissoes: ["respostas#index_show"],
    },
  },
  {
    name: "RespostaEdit",
    path: "/respostas/resposta-edit/:id",
    component: RespostaEdit,
    meta: {
      requerPermissao: true,
      label: "Respostas",
      permissoes: ["respostas#new_edit_destroy"],      
    },
  },
  {
    name: "NaoEncontrado",
    path: "/nao-encontrado",
    component: NaoEncontrado,
  },
  {
    path: "*",
    redirect: (to) => {
      return { name: "NaoEncontrado", query: { url: to.path } };
    },
  },
];